module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input"
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 24 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "x1": "0%",
      "y1": "100%",
      "x2": "98.4753667%",
      "y2": "1.52463329%",
      "id": "linearGradient-1"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF7950",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#F42C2A",
      "offset": "100%"
    }
  })], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icons/Light/Cards/ic_hba1c"
    }
  }, [_c('g', {
    attrs: {
      "id": "ic_bloodglucose"
    }
  }, [_c('rect', {
    attrs: {
      "id": "bounds",
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.7141425,15.4206675 C16.7141425,14.3305871 16.3089743,12.0255408 14.6252466,9.85941762 C13.1714601,7.98914179 10.8003551,3 10.8003551,3 C10.8003551,3 8.54268237,7.98914179 7.08889592,9.85938459 C5.40516818,12.0255078 5,14.330554 5,15.4206675 C5,18.2970952 7.58662631,20.6348409 10.8003551,20.6887454 L10.8003551,20.6900005 C10.8192976,20.6900005 10.8381659,20.6895051 10.8570712,20.689373 C10.8760137,20.6895381 10.894882,20.6900005 10.9138244,20.6900005 L10.9138244,20.6887454 C14.1275162,20.6348409 16.7141425,18.2970952 16.7141425,15.4206675 L16.7141425,15.4206675 Z",
      "id": "Shape",
      "fill": "url(#linearGradient-1)"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.3372489,11.445418 L10.3372489,11.445418 L10.3372489,11.445418 C10.0734114,11.7092555 10.0728335,12.1368422 10.3359569,12.4013919 L13.3932177,15.4752261 L13.3932177,15.4752261 C13.7826849,15.8668046 14.4158475,15.8685161 14.8074261,15.4790489 C14.808048,15.4784303 14.8086692,15.4778109 14.8092895,15.4771906 L16.136795,14.1498748 L18.6001799,16.6132598 L18.6001799,16.6132598 C18.8637287,16.8768085 19.2910256,16.8768085 19.5545743,16.6132598 L19.5545743,16.6132598 L19.5545743,16.6132598 C19.815976,16.351858 19.815976,15.9280421 19.5545743,15.6666403 C19.5532838,15.6653498 19.551988,15.6640646 19.550687,15.6627847 L16.8119508,12.96849 L16.8119508,12.96849 C16.4204799,12.5833715 15.7916925,12.5859891 15.4034415,12.9743535 L14.1121987,14.2659734 L11.2919132,11.4454391 L11.2919132,11.4454391 C11.0283074,11.18181 10.6008991,11.1817911 10.33727,11.4453969 C10.337263,11.445404 10.3372559,11.445411 10.3372489,11.445418 Z",
      "id": "Page-1",
      "fill": "#B8E986",
      "transform": "translate(14.944809, 14.029313) rotate(3.000000) translate(-14.944809, -14.029313) "
    }
  })])])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    staticStyle: {
      "color": "#FB5940"
    },
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": _vm.isOpenInput ? 'remove_circle_outline' : 'add_circle'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "novalidate": ""
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.$store.state.user.settings.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.percent),
      callback: function($$v) {
        _vm.$set(_vm.model, "percent", _vm._n($$v))
      },
      expression: "model.percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.cardHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.model, "mmol_mol", _vm._n($$v))
      },
      expression: "model.mmol_mol"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b0e159","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddProgress/aio-components/HbA1c/HbA1c.vue
// module id = 3762
// module chunks = 1